module.exports = __webpack_public_path__ + "static/media/flower.6f44bc74.png";